import type {
  ReactElement,
} from 'react';

import type {
  AxiosError,
} from 'axios';

import { ErrorPage } from '../ErrorPage';

export type AxiosErrorPageProps = {
  /**
   * Ошибка axios
   */
  error: AxiosError;
};

export function AxiosErrorPage({
  error,
}: AxiosErrorPageProps): ReactElement {
  if (error.response) {
    return (
      <ErrorPage
        status={error.response.status}
      />
    );
  }

  return (
    <ErrorPage
      status={503}
    />
  );
}
